import type { ThemeName } from "../theme.js";

export type ConvoyPalette = {
  ground: string;
  meadow: string;
  roadCasing: string;
  roadSurface: string;
  roadDash: string;
  forest: string;
  forestEdge: string;
  forestSpeckle: string;
  vehicle: string;
  vehicleLabel: string;
  vehicleDead: string;
  vehicleSmoke: string;
  drone: string;
  droneUntracked: string;
  droneTrail: string;
  shot: string;
  owShot: string;
  kill: string;
  impact: string;
  rangeSensor: string;
  rangeWeapon: string;
  rangeWeaponEdge: string;
  overwatch: string;
  overwatchRing: string;
  scaleBar: string;
  /** Solid colour the convoy dead-ground mask is painted in. */
  deadGround: string;
  /** Alpha the convoy dead-ground mask is composited at. */
  deadGroundAlpha: number;
  /** Solid colour for the area hidden from the overwatch platform. */
  owHidden: string;
  owHiddenAlpha: number;
};

const LIGHT: ConvoyPalette = {
  ground: "#f3ecdb",
  meadow: "rgba(168, 186, 140, 0.18)",
  roadCasing: "#c97f3f",
  roadSurface: "#fcb070",
  roadDash: "rgba(255, 255, 255, 0.75)",
  forest: "rgba(104, 134, 89, 0.92)",
  forestEdge: "rgba(73, 99, 64, 0.9)",
  forestSpeckle: "rgba(134, 160, 116, 0.55)",
  vehicle: "#1f4795",
  vehicleLabel: "#f3f1ea",
  vehicleDead: "#7a6e58",
  vehicleSmoke: "rgba(90, 90, 90, 0.5)",
  drone: "#c0392b",
  droneUntracked: "rgba(138, 90, 74, 0.55)",
  droneTrail: "rgba(192, 57, 43, 0.35)",
  shot: "31, 71, 149",
  owShot: "29, 107, 63",
  kill: "#1d6b3f",
  impact: "#c0392b",
  rangeSensor: "rgba(90, 82, 70, 0.12)",
  rangeWeapon: "rgba(31, 71, 149, 0.05)",
  rangeWeaponEdge: "rgba(31, 71, 149, 0.20)",
  overwatch: "#1d6b3f",
  overwatchRing: "rgba(29, 107, 63, 0.35)",
  scaleBar: "#6e6553",
  deadGround: "#2e3440",
  deadGroundAlpha: 0.16,
  owHidden: "#1d6b3f",
  owHiddenAlpha: 0.16,
};

const DARK: ConvoyPalette = {
  ground: "#0a1f33",
  meadow: "rgba(56, 117, 246, 0.05)",
  roadCasing: "#7a4a18",
  roadSurface: "#e8a04a",
  roadDash: "rgba(2, 16, 34, 0.6)",
  forest: "rgba(18, 56, 38, 0.95)",
  forestEdge: "rgba(38, 92, 62, 0.9)",
  forestSpeckle: "rgba(62, 122, 86, 0.55)",
  vehicle: "#3875F6",
  vehicleLabel: "#e9f4ff",
  vehicleDead: "#5a4a30",
  vehicleSmoke: "rgba(150, 150, 150, 0.35)",
  drone: "#ef6868",
  droneUntracked: "rgba(122, 58, 58, 0.6)",
  droneTrail: "rgba(239, 104, 104, 0.4)",
  shot: "56, 117, 246",
  owShot: "108, 217, 159",
  kill: "#6cd99f",
  impact: "#ef6868",
  rangeSensor: "rgba(138, 162, 184, 0.08)",
  rangeWeapon: "rgba(56, 117, 246, 0.06)",
  rangeWeaponEdge: "rgba(56, 117, 246, 0.25)",
  overwatch: "#6cd99f",
  overwatchRing: "rgba(108, 217, 159, 0.4)",
  scaleBar: "#8aa2b8",
  deadGround: "#000000",
  deadGroundAlpha: 0.38,
  owHidden: "#6cd99f",
  owHiddenAlpha: 0.12,
};

export function getConvoyPalette(theme: ThemeName): ConvoyPalette {
  return theme === "light" ? LIGHT : DARK;
}
